<template>
  <div class="curva-s-grafico">
    <h3 class="grafico-title">Curva S</h3>
    <div class="chart-container">
      <canvas ref="canvas"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
  name: 'CurvaSGrafico',
  props: {
    boletinsMedicao: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    chartData() {
      const labels = this.boletinsMedicao.map(bm => bm.label || bm.nome);
      const previstoData = this.boletinsMedicao.map(bm => bm.previstoAPerc);
      const realizadoData = this.boletinsMedicao.map(bm => bm.realizadoAPerc);

      return {
        labels,
        datasets: [
          {
            label: 'Previsto (Acumulado)',
            data: previstoData,
            borderColor: '#48e8c7',
            backgroundColor: 'rgba(72, 232, 199, 0.1)',
            borderWidth: 3,
            fill: false,
            lineTension: 0.4,
            pointRadius: 4,
            pointBackgroundColor: '#48e8c7',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointHoverRadius: 6
          },
          {
            label: 'Realizado (Acumulado)',
            data: realizadoData,
            borderColor: '#ff92ae',
            backgroundColor: 'rgba(255, 146, 174, 0.1)',
            borderWidth: 3,
            fill: false,
            lineTension: 0.4,
            pointRadius: 4,
            pointBackgroundColor: '#ff92ae',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointHoverRadius: 6
          }
        ]
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          align: 'start',
          labels: {
            usePointStyle: true,
            padding: 15,
            fontSize: 11,
            fontStyle: 'bold',
            boxWidth: 8
          }
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleFontSize: 13,
          titleFontStyle: 'bold',
          bodyFontSize: 12,
          xPadding: 12,
          yPadding: 12,
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.datasets[tooltipItem.datasetIndex].label || '';
              const value = tooltipItem.yLabel;
              return `${label}: ${value.toFixed(1).replace('.', ',')}%`;
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Boletim de Medição',
              fontSize: 13,
              fontStyle: 'bold',
              fontColor: '#626568'
            },
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)'
            },
            ticks: {
              fontSize: 10,
              fontColor: '#626568',
              maxRotation: 0,
              minRotation: 0
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Percentual (%)',
              fontSize: 13,
              fontStyle: 'bold',
              fontColor: '#626568'
            },
            ticks: {
              beginAtZero: true,
              fontSize: 11,
              fontColor: '#626568',
              callback: (value) => `${value.toFixed(0)}%`
            },
            gridLines: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }]
        },
        hover: {
          mode: 'nearest',
          intersect: false
        }
      };
    }
  },
  mounted() {
    this.renderChart();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
  watch: {
    boletinsMedicao: {
      deep: true,
      handler() {
        this.renderChart();
      }
    }
  },
  methods: {
    renderChart() {
      if (this.chart) {
        this.chart.destroy();
      }
      
      const ctx = this.$refs.canvas.getContext('2d');
      this.chart = new Chart(ctx, {
        type: 'line',
        data: this.chartData,
        options: this.chartOptions
      });
    }
  }
};
</script>

<style scoped>
.curva-s-grafico {
  margin-top: 40px;
  padding: 20px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.grafico-title {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  color: #626568;
}

.chart-container {
  position: relative;
  height: 400px;
  width: 100%;
}
</style>